export enum PROVIDERS {
    /**
     * @value Identity providers
     */
    IDP = 'ADMIN.NAV.PROVIDER.IDP',
    /**
     * @value Services provider
     */
    SERVICE = 'ADMIN.NAV.PROVIDER.SERVICE',
}
